import {Input, Language, Output, TranslationResult, TranslationsBody} from './Configuration';
import {SessionContext} from './SessionContext';
import HybridModelSessionContext from './HybridModelSessionContext';
import {CancellationReason} from 'microsoft-cognitiveservices-speech-sdk/distrib/lib/src/sdk/Exports';
import {UUID} from 'crypto';

let currentSessionContext: SessionContext | HybridModelSessionContext | null;

export function createSessionContext(modelType: string,
                                     azureSpeechAPIToken?: string,
                                     sessionId?: UUID,
                                     selectedInput?: Input, selectedOutputs?: Output[],
                                     onPartialRecognitionReady?: (recognizedText: string) => void,
                                     onRecognitionReady?: (recognizedText: string) => void,
                                     onPartialTranslationReady?: (translationReady: Map<Language, TranslationResult>) => void,
                                     onTranslationReady?: (translationsBody: TranslationsBody) => void,
                                     onSessionCanceled?: (sessionId: UUID, azureSessionId: string, reason: CancellationReason) => void
): SessionContext | HybridModelSessionContext {

    if (!azureSpeechAPIToken || !sessionId || !selectedInput || !selectedOutputs || !onPartialRecognitionReady || !onRecognitionReady || !onPartialTranslationReady || !onTranslationReady || !onSessionCanceled) {
        if (currentSessionContext)
            return currentSessionContext;
        else
            throw new Error('SessionContext was not initialized')
    }

    if (!currentSessionContext || ('STOPPED' === currentSessionContext.getState())) {
        currentSessionContext = 'hybridModel' === modelType ?
            new HybridModelSessionContext(azureSpeechAPIToken, sessionId, selectedInput, selectedOutputs, onPartialRecognitionReady, onRecognitionReady, onPartialTranslationReady, onTranslationReady, onSessionCanceled) :
            new SessionContext(modelType, azureSpeechAPIToken, sessionId, selectedInput, selectedOutputs, onPartialRecognitionReady, onRecognitionReady, onPartialTranslationReady, onTranslationReady, onSessionCanceled);
    }
    return currentSessionContext;
}

export function getSessionContext(): SessionContext | HybridModelSessionContext | null {
    return currentSessionContext;
}
